import { memo } from 'react';

import { cn } from '../../lib/styles';

interface LoaderProps {
  className?: string;
  variant?: 'thin' | 'thick';
  inverted?: boolean;
}

const LoaderBase = ({ className, inverted = false, variant = 'thin' }: LoaderProps) => {
  if (variant === 'thick') {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn('animate-spin', className)}
      >
        <path
          d="M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10ZM5.8 10C5.8 12.3196 7.6804 14.2 10 14.2C12.3196 14.2 14.2 12.3196 14.2 10C14.2 7.6804 12.3196 5.8 10 5.8C7.6804 5.8 5.8 7.6804 5.8 10Z"
          fill={inverted ? '#757575' : '#D4D4D4'}
        />
        <path
          d="M9.87783 3.00107C11.3559 2.97527 12.8041 3.41804 14.015 4.26594C15.226 5.11383 16.1374 6.32331 16.6186 7.72102C17.0999 9.11874 17.1263 10.6329 16.6941 12.0466C16.2619 13.4603 15.3933 14.7008 14.2127 15.5904L12.5276 13.3543C13.236 12.8205 13.7572 12.0762 14.0165 11.228C14.2758 10.3798 14.2599 9.47124 13.9712 8.63261C13.6824 7.79398 13.1356 7.0683 12.409 6.55956C11.6825 6.05083 10.8135 5.78516 9.9267 5.80064L9.87783 3.00107Z"
          fill={inverted ? '#FFFFFF' : '#1D1D1D'}
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 21 21"
      fill="none"
      className={cn('animate-spin', className)}
    >
      <path
        d="M20.5 10.5C20.5 16.0228 16.0228 20.5 10.5 20.5C4.97715 20.5 0.5 16.0228 0.5 10.5C0.5 4.97715 4.97715 0.5 10.5 0.5C16.0228 0.5 20.5 4.97715 20.5 10.5ZM2.5 10.5C2.5 14.9183 6.08172 18.5 10.5 18.5C14.9183 18.5 18.5 14.9183 18.5 10.5C18.5 6.08172 14.9183 2.5 10.5 2.5C6.08172 2.5 2.5 6.08172 2.5 10.5Z"
        fill={inverted ? '#757575' : '#D9D9D9'}
      />
      <path
        d="M16.864 16.864C17.2545 17.2545 17.2574 17.8921 16.8298 18.2417C15.8204 19.067 14.6567 19.6891 13.4028 20.0694C11.8291 20.5468 10.162 20.6287 8.5491 20.3079C6.93619 19.987 5.42729 19.2734 4.15607 18.2301C2.88484 17.1868 1.89053 15.8462 1.2612 14.3268C0.631878 12.8075 0.386963 11.1564 0.548153 9.51983C0.709343 7.88324 1.27166 6.31166 2.1853 4.9443C3.09894 3.57694 4.3357 2.456 5.78603 1.68079C6.94159 1.06313 8.20431 0.680128 9.50165 0.549958C10.0512 0.49482 10.5 0.947715 10.5 1.5C10.5 2.05228 10.0506 2.49356 9.50259 2.56242C8.53462 2.68405 7.59417 2.9821 6.72883 3.44463C5.56856 4.0648 4.57916 4.96155 3.84824 6.05544C3.11733 7.14933 2.66747 8.40659 2.53852 9.71586C2.40957 11.0251 2.6055 12.346 3.10896 13.5615C3.61243 14.7769 4.40788 15.8495 5.42485 16.6841C6.44183 17.5187 7.64895 18.0896 8.93928 18.3463C10.2296 18.6029 11.5633 18.5374 12.8223 18.1555C13.7612 17.8707 14.637 17.4164 15.4074 16.818C15.8436 16.4792 16.4734 16.4734 16.864 16.864Z"
        fill={inverted ? '#FFFFFF' : '#1D1D1D'}
      />
    </svg>
  );
};

export const Loader = memo(LoaderBase);
